import { get, post } from '@/utils/apiBase.js';

// 获取跳转在线客服链接
const getSobotUrl = option => {
  return get('/apis/user_auth/get_sobot_url', option)
}
// 获取cp发起的众筹
const getBuildProductList = option => {
  return get('/apis/user_center/build_product_list', option)
}
// 获取登录CP个人信息
const GetUserInfo = (option) => {
  return get('/apis/comm/user/user_info', option);
};
// 获取用户融云token
const getIMToken = (option) => {
  return get('/im/utoken', option);
};
// 获取个人中心未读总数
const getMessageUnread = (option) => {
  return get('/apis/user_center/get_message_unread', option);
};
// 获取用户cp标签
const GetUserCpTag = (option) => {
  return get('/apis/user/user_cp_tag', option);
};

// 个人中心获取lockerr code
const getLockerrCode = (option) => {
  return get('/apis/user_center/get_lockerr_code', option);
};

// 获取用户PC站内信
const getPCMessageList = (option) => {
  return get('/apis/user_center/get_cp_message_list', option);
}

// 设置用户PC站内信为已读
const setPCMessageRead = (option) => {
  return post('/apis/user_center/read_pc_message', option)
}

export default {
  getSobotUrl,
  getBuildProductList,
  GetUserInfo,
  getIMToken,
  getMessageUnread,
  GetUserCpTag,
  getLockerrCode,
  getPCMessageList,
  setPCMessageRead
};
